export default __webpack_public_path__ + "i18n/translations/translation-ar.75fcc633.json";